import React, {useEffect, useRef} from 'react';
import {Animated, Easing, View} from 'react-native';
import CCColors from '@/Utils/CCColors';

const Dot = ({delay}: {delay: number}) => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.delay(delay),
        Animated.timing(opacity, {
          toValue: 1,
          duration: 350,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: false,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 350,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: false,
        }),
        Animated.delay(600 - delay),
      ]),
    );
    animation.start();
    return () => animation.stop();
  }, [delay, opacity]);

  return (
    <Animated.View
      style={{
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: CCColors.Red,
        marginHorizontal: 2,
        opacity,
      }}
    />
  );
};

// Three softly pulsing dots, staggered — used wherever Caissa is "thinking".
function TypingDots() {
  return (
    <View style={{flexDirection: 'row', alignItems: 'center'}}>
      <Dot delay={0} />
      <Dot delay={150} />
      <Dot delay={300} />
    </View>
  );
}

export default TypingDots;
